import { render, staticRenderFns } from "./HeaderFolderButtons.vue?vue&type=template&id=1dc40449"
import script from "./HeaderFolderButtons.vue?vue&type=script&lang=js"
export * from "./HeaderFolderButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports